import React, { useEffect, useState } from 'react'
import Container from '../../../ui/comp/Container'
import Input from '../../../ui/forms/Input'
import TextArea from '../../../ui/forms/TextArea'
import { displayImage } from '../../../utils/config'
import Button from '../../../ui/comp/Button'
import { useMutation, useQuery } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { Axios, baseURL } from '../../../utils/Axios'
import axios from 'axios'

function Seo() {

    const [seoData, setSeoData] = useState({
        favicon: "", meta_title: "", meta_description: "",
        meta_url: "", meta_keywords: "", meta_image: ""
    })

    // FetchData

    const { data } = useQuery({
        queryKey: ["seo"],
        queryFn: async () => {
            const res = await Axios.get('/store/seo')
            return res.data
        }
    })

    useEffect(() => {
        setSeoData(data || {
            favicon: "", meta_title: "", meta_description: "",
            meta_url: "", meta_keywords: "", meta_image: ""
        })
    }, [data])


    // input onchage

    const inputChange = (e) => {
        const { id, value } = e.target;
        setSeoData({ ...seoData, [id]: value })
    }


    const fileChangeSeo = async (files, field) => {
        if (files?.length) {
            const formData = new FormData();

            Object.keys(files).forEach(key => {
                formData.append('file', files[key])
            })
            try {
                const res = await axios.post(`${baseURL}/upload`, formData)
                const data = await res.data;
                setSeoData({ ...seoData, [field]: data[0] })
                toast.success('File Uploaded')
            } catch (error) {
                toast.error(error?.response?.data || "Error while uploading file")
            }
        }
    }


    // Send Data

    const { mutate, isPending } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/store/seo', formData)
        },
        onError: (error) => {
            toast.error(error?.response?.data || error.message)
        },
        onSuccess: () => {
            toast.success("Header updated")
        }
    })

    const sendData = () => {
        mutate(seoData)
    }

    return (
        <div className='w-full relative'>
            <Container>
                <div className="space-y-4">
                    {/* Favicon */}
                    <div className="flex items-center gap-3">
                        <div className="w-32"> <p>Favicon</p></div>
                        <div className="w-full">
                            <input type="file" id='file' onChange={(e) => fileChangeSeo(e.target.files, 'favicon')} />
                            <div className="mt-2">
                                <img src={displayImage(seoData?.favicon)} alt="" className="w-24 p-1 border" />
                            </div>
                        </div>
                    </div>

                    {/* Meata Title */}
                    <div className="flex items-center gap-3">
                        <div className="w-32"> <p>Meta Title</p></div>
                        <div className="w-full">
                            <Input id="meta_title" value={seoData?.meta_title} onChange={inputChange} />
                        </div>
                    </div>

                    {/* Meta Description */}
                    <div className="flex items-center gap-3">
                        <div className="w-32"> <p>Meta Description</p></div>
                        <div className="w-full">
                            <TextArea id="meta_description" value={seoData?.meta_description} onChange={inputChange} />
                        </div>
                    </div>

                    {/* Meta Url */}
                    <div className="flex items-center gap-3">
                        <div className="w-32">  <p>Meta Url</p></div>
                        <div className="w-full">
                            <Input id='meta_url' value={seoData?.meta_url} onChange={inputChange} />
                        </div>
                    </div>

                    {/* Meta Keywords */}
                    <div className="flex items-center gap-3">
                        <div className="w-32"> <p>Meta Keywords</p></div>
                        <div className="w-full">
                            <TextArea id='meta_keywords' value={seoData?.meta_keywords} onChange={inputChange} />
                        </div>
                    </div>

                    {/* Meta Image */}
                    <div className="flex items-center gap-3">
                        <div className="w-32"> <p>Meta Image</p></div>
                        <div className="w-full">
                            <input type="file" id='file' onChange={(e) => fileChangeSeo(e.target.files, 'meta_image')} />
                            <div className="mt-2">
                                <img src={displayImage(seoData?.meta_image)} alt="" className="w-24 p-1 border" />
                            </div>
                        </div>
                    </div>
                </div>


                {/* Bu */}
                <div className="mt-6">
                    <Button onClick={sendData} loading={isPending}>Update</Button>
                </div>
            </Container>
        </div>
    )
}

export default Seo